interface Device {
  rssi?: number
}

export function nearestDevice<T extends Device>(devices: T[]) {
  const sorted = [...devices].sort((a, b) => (b.rssi || -255) - (a.rssi || -255))
  return sorted[0]
}
